import React, { Component, Fragment } from 'react';
import ClassNames from 'classnames';
import ConfirmationBranchListPopup from 'Components/ConfirmationBranchListPopUp';
import Checkbox from 'Components/Checkbox';
import {ReactComponent as DownArrow} from 'Icons/downArrow.svg';
import {ReactComponent as EditIcon} from 'Icons/edit.svg';
import {ReactComponent as CancelIcon} from 'Icons/cancel.svg';
import {ReactComponent as DeleteIcon} from 'Icons/delete.svg';
import SwitchBox  from "../Switch/SwitchBox";
import { isAdaniWilmar } from 'Utils/';
import { DEEPAK_PHENOLICS, RAJPETRO } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';

class GroupContainer extends Component {
    constructor(props) {
        super(props);
        const grpId = props.group.id;
        this.state = {
            isTransportersShown : true,
            groupName: {
                [grpId]: props.group.name,
            },
            selectedOption: null,
            selectedOptionList:[],
            isBranchPopupShown:false
        }
    }
    toggleTransporters = ()=> {
        this.setState({
            isTransportersShown: !this.state.isTransportersShown
        });
    }

    onChange=(e)=> {
        this.setState({
            [e.target.name]: e.target.value,
            selectedOption:null
        })
    }

    handleBranchSelection = (selectedOption) => {
            this.setState({
                selectedOption ,
                selectedOptionList:[]
            });
    }

    showBranchPopup = ()=>{
        const { group , branchesList, providerType }  = this.props;
        let { selectedOption } = this.state;
        if( group && selectedOption && selectedOption.length > 0 && Object.keys(group).length > 0 && group.branch_Id ){
        selectedOption = branchesList.filter(branch =>{
            return group.branch_Id.indexOf(branch.value) > -1;
        })

         }else{
         this.setState({
            branchesList
         })
         }

         if(group && branchesList && branchesList.length > 0 && Object.keys(group).length > 0 && group.branch_Id){
            selectedOption = branchesList.filter(branch =>{
                return group.branch_Id.indexOf(branch.value) > -1;
            })
         }
        this.setState({
            isBranchPopupShown: providerType === 24 ? false : true,
            selectedOption
        })
       }
       cancelPopUp=()=>{
        // const { group , branchesList }  = this.props;
        //let { selectedOption , selectedOptionList} = this.state;
        // if(selectedOption && selectedOption.length>0 && group.branch_Id!==null){
        // selectedOption = branchesList.filter(branch =>{
        //     return group.branch_Id.indexOf(branch.value) > -1;
        // })
        
        // selectedOptionList=[];
        // selectedOption.forEach((item) => {
        //    selectedOptionList.push(item.value);
        //  });
        //  this.props.branchModified(selectedOptionList);
        // }
        this.setState({
            isBranchPopupShown: false,
            selectedOptionList: []
        });
        
    }

    confirmPopUp=()=>{
        let { selectedOption , selectedOptionList} = this.state;
        this.setState({
            selectedOptionList:[]
        });
        if(selectedOption && selectedOption.length>0){
        selectedOption.forEach((item) => {
            selectedOptionList.push(item.value);
          });
        }
        this.props.branchModified(selectedOptionList);
        this.setState({
            isBranchPopupShown:false,
        });
    }
    onGroupNameChange = (e) => {
        const { group } = this.props;
        const { groupName } = this.state;
        groupName[group.id] = e.target.value
        this.setState({
            groupName 
        }, () => {
            this.props.nameModified(this.state.groupName[group.id]);
        });
    }
    // addTransporterToGroup = () => {
    //     if (this.props.group) {
    //         this.props.editTransporterGroup(this.props.group.id);
    //     }
    // }
    handleRemoveTransporter = (transporter) => {
        this.props.removeTransporterFromGroup(transporter.id);
    }

    handleChangeActive =(groupId, transporterId, status)=>{
    this.props.activeOrdeactivatedTransporter(groupId, transporterId, status);
    }

    render() {
        const { group, selectedList, selectedTransporters, editingGroup ,  branchesList, viewMode, providerType, disableIndividualSelection} = this.props;
        const inEditMode =  group.id && editingGroup ? (group.id === editingGroup) : false;
        return (
            <>
            {(viewMode ? true : (group.transporters || []).filter(trans => trans.is_active).length > 0) && <div>
                <div className={ClassNames("bg-theme-light flex ht-40 fs-16 fSemibold flex flex-middle flex-between mt-20", {
                    
                })}>
                    <DownArrow onClick={this.toggleTransporters} className={ClassNames("pa ml-10", {
                        'rotate-180': this.state.isTransportersShown,
                        'rotate-0': !this.state.isTransportersShown
                    })}/>
                    <div className="pl-40 flex-1 row-100 flex flex-middle pr-15">
                        {
                            inEditMode
                            ?
                                <Fragment>
                                    <input  
                                        type="text"
                                        className="pl-10 fs-16 border-light ht-30 br-5 wt-150"
                                        // value={(this.state.groupName === group.name) ? group.name : this.state.groupName}
                                        value={this.state.groupName[group.id] ? this.state.groupName[group.id] : group.name}
                                        onChange={this.onGroupNameChange}
                                    />
                                    {providerType !== 24 && <span className="theme-color fs-12 fSemibold curP mr-left-4"  onClick={this.showBranchPopup}>Edit Branch</span>}
                                    { this.state.isBranchPopupShown&&   
                                        <ConfirmationBranchListPopup text={'Select Branch'}
                                            branchList={branchesList}
                                            selected={this.state.selectedOption}
                                            handleBranchSelection ={this.handleBranchSelection}
                                            Confirm = {this.confirmPopUp}
                                            onCancel = {this.cancelPopUp}
                                    />}                 
                                </Fragment>
                                
                            :
                            <div className="wt-80p curP" onClick={this.toggleTransporters}>{group.name}</div> 
                        }
                        
                        
                    </div>
                    {!selectedList && <Checkbox type='square' onCheck={this.props.toggleAllTransporters} disabled={this.props.autoSelectTransporters} checked={selectedTransporters.length === group.transporters.filter(trans => trans.is_active).length}/>}
                </div>
                <div className={ClassNames("bg-white height-transition box-shadow br-5", {
                    'disabled curNA': this.props.autoSelectTransporters
                })}
                style={{
                    overflowY: 'hidden',
                    height: 40*(viewMode ? group.transporters.length : group.transporters.filter(trans => trans.is_active).length)*(this.state.isTransportersShown?1:0)
                }}
                >
                    {
                        group.transporters.map((transporter, index)=> {
                            return (
                                <>
                                {(viewMode ? true : transporter.is_active) && <div key={index} className="flex ht-40 fs-16 fSemibold flex flex-middle pl-40 flex-between">
                                    <label className="wt-87p" htmlFor={"group-transporter" + group.id + transporter.id}>
                                        {transporter.name}
                                    </label>
                                    {
                                        inEditMode && 
                                        <span className="wt-20 ht-20 wt-10p" onClick={() => this.handleRemoveTransporter(transporter)}>
                                            <DeleteIcon className="wt-20 ht-20 tRight curP" />
                                        </span>
                                    } 
                                    {!selectedList && !disableIndividualSelection && <Checkbox type='square' id={"group-transporter" + group.id + transporter.id} onCheck={()=> {
                                        this.props.toggleTransporter(transporter);
                                    }}
                                    checked={selectedTransporters.indexOf(transporter.id) > -1}
                                    />}
                                    { viewMode && 
                                    // (isAdaniWilmar() || [...RAJPETRO, ...DEEPAK_PHENOLICS].includes(getUser().companyId)) && 
                                    <SwitchBox transporter={transporter} groupId={group.id} handleChangeActive={this.handleChangeActive}></SwitchBox>}
                                </div>}
                                </>
                            )
                        })
                    }
                </div>
                {
                    // inEditMode && <button className="ht-30 br-20 theme-color border-theme fs-16 fBold pl-20 pr-20 mr-20" onClick={this.addTransporterToGroup}>Add</button>
                }
            </div>}
            </>
        )
    }
}

export default GroupContainer;
